import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import _m from "moment";
import { PublicationService } from "../publication-results/publication-refinement.service";
import { LOCAL_STORAGE_KEYS } from "src/app/shared/constants/storage-keys";

@Component({
    selector: "tdms-applied-filters",
    templateUrl: "./applied-filters.component.html",
    styleUrls: ["./applied-filters.component.scss"],
    standalone: false
})
export class AppliedFiltersComponent implements OnInit {
  @Output() isApplyFilterTriggered = new EventEmitter<boolean>();

  selectedPubFilterValues: string[] =
    localStorage.getItem(LOCAL_STORAGE_KEYS.PUB_FILTERS) === null
      ? []
      : JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.PUB_FILTERS));
  selectedDocFilterValues: string[] =
    localStorage.getItem(LOCAL_STORAGE_KEYS.DOC_FILTERS) === null
      ? []
      : JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DOC_FILTERS));
  selectedSourceTypeFilterValues: string[] =
    localStorage.getItem(LOCAL_STORAGE_KEYS.SOURCE_FILTERS) === null
      ? []
      : JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.SOURCE_FILTERS));
  fDate: string =
    localStorage.getItem(LOCAL_STORAGE_KEYS.FROM_DATE) === null
      ? ""
      : JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.FROM_DATE)).slice(0, 10);
  tDate: string =
    localStorage.getItem(LOCAL_STORAGE_KEYS.TO_DATE) === null
      ? ""
      : JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.TO_DATE)).slice(0, 10);
  isDateFilter: boolean = this.fDate !== "" || this.tDate !== "";

  constructor(private pubservice: PublicationService) {}

  ngOnInit(): void {
    console.log(this.selectedPubFilterValues);
  }

  getDateFilter(): string {
    if (this.fDate === "") {
      return "before " + _m(this.tDate).format("MMM DD, YYYY");
    }
    if (this.tDate === "") {
      return "after " + _m(this.fDate).format("MMM DD, YYYY");
    }
    return _m(this.fDate).format("MMM DD, YYYY") + " to " + _m(this.tDate).format("MMM DD, YYYY");
  }

  triggerFilters() {
    this.isApplyFilterTriggered.emit(true);
  }

  clearAllFilters() {
    this.pubservice.clearFilters();
    this.triggerFilters();
  }

  removeSourceTypeFilter(removeFilter: string) {
    if (this.selectedSourceTypeFilterValues.filter((filter) => filter !== removeFilter).length > 0) {
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.SOURCE_FILTERS,
        JSON.stringify(this.selectedSourceTypeFilterValues.filter((filter) => filter !== removeFilter))
      );
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.SOURCE_FILTERS);
    }
    this.triggerFilters();
  }

  removeDocTypeFilter(removeFilter: string) {
    if (this.selectedDocFilterValues.filter((filter) => filter !== removeFilter).length > 0) {
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.DOC_FILTERS,
        JSON.stringify(this.selectedDocFilterValues.filter((filter) => filter !== removeFilter))
      );
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.DOC_FILTERS);
    }

    this.triggerFilters();
  }

  removePubTypeFilter(removeFilter: string) {
    if (this.selectedPubFilterValues.filter((filter) => filter !== removeFilter).length > 0) {
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.PUB_FILTERS,
        JSON.stringify(this.selectedPubFilterValues.filter((filter) => filter !== removeFilter))
      );
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.PUB_FILTERS);
    }

    this.triggerFilters();
  }

  removeDateFilter() {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.FROM_DATE);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TO_DATE);
    this.triggerFilters();
  }
}
